export const PAYMENT_METHOD_ORDER = {
  DELIVERY: 1,
  ONLINE: 2,
} as const;
